import { call, put, all, StrictEffect, takeLatest } from 'redux-saga/effects';
import fetchAPI from '@utils/fetchAPI';
import DomainByEnv from '@utils/domainByEnv';
import * as actionTypes from '../actionTypes';
import * as actions from '../actions';

const searchRoute = `${DomainByEnv()}/search`;
const detailRoute = `${DomainByEnv()}/detail`;

function* setDepthinfoAsync(action: actions.I_DepthinfoAction): Generator<StrictEffect, any, any> {
    const DepthInfo = yield call(fetchAPI, {
        url: `${searchRoute}/depthinfojson`,
        req: action.payload,
    });
    yield put(actions.setDepthinfoSUCCESS(DepthInfo));
}

function* watchSetDepthinfoAsync() {
    yield takeLatest(actionTypes.SET_DEPTHINFO, setDepthinfoAsync);
}

function* setPopularinfoAsync(
    action: actions.I_PopularinfoAction
): Generator<StrictEffect, any, any> {
    const PopularInfo = yield call(fetchAPI, {
        url: `${detailRoute}/popularinfojson`,
        req: action.payload,
    });
    yield put(actions.setPopularinfoSUCCESS(PopularInfo));
}

function* watchsetPopularinfoAsync() {
    yield takeLatest(actionTypes.SET_POPULARINFO, setPopularinfoAsync);
}

function* setGroupListInfoAsync(
    action: actions.I_GroupListInfoAction
): Generator<StrictEffect, any, any> {
    const groupListInfo = yield call(fetchAPI, {
        url: `${searchRoute}/grouplistinfojson`,
        req: action.payload,
    });
    yield put(actions.setGroupListInfoSUCCESS(groupListInfo));
}

function* watchSetGroupListInfoAsync() {
    yield takeLatest(actionTypes.SET_GROUPLISTINFO, setGroupListInfoAsync);
}

function* setGroupListInfoMAsync(
    action: actions.I_GroupListInfoAction
): Generator<StrictEffect, any, any> {
    const groupListInfo = yield call(fetchAPI, {
        url: `${searchRoute}/grouplistinfojson`,
        req: action.payload,
    });
    yield put(actions.setGroupListInfoMSUCCESS(groupListInfo));
}

function* watchSetGroupListInfoMAsync() {
    yield takeLatest(actionTypes.SET_GROUPLISTINFOM, setGroupListInfoMAsync);
}

function* setSingleGroupListInfoAsync(
    action: actions.I_GroupListInfoMAction
): Generator<StrictEffect, any, any> {
    const singleGroupListInfo = yield call(fetchAPI, {
        url: `${searchRoute}/singlegrouplistinfojson`,
        req: action.payload,
    });
    yield put(actions.setSingleGroupListInfoSUCCESS(singleGroupListInfo));
}

function* watchSetSingleGroupListInfoAsync() {
    yield takeLatest(actionTypes.SET_SINGLEGROUPLISTINFO, setSingleGroupListInfoAsync);
}

function* setSingleGroupListInfoMAsync(
    action: actions.I_GroupListInfoMAction
): Generator<StrictEffect, any, any> {
    const singleGroupListInfo = yield call(fetchAPI, {
        url: `${searchRoute}/singlegrouplistinfojson`,
        req: action.payload,
    });
    yield put(actions.setSingleGroupListInfoMSUCCESS(singleGroupListInfo));
}

function* watchSetSingleGroupListInfoMAsync() {
    yield takeLatest(actionTypes.SET_SINGLEGROUPLISTINFOM, setSingleGroupListInfoMAsync);
}

export default function* rootSaga() {
    yield all([
        watchSetDepthinfoAsync(),
        watchsetPopularinfoAsync(),
        watchSetGroupListInfoAsync(),
        watchSetGroupListInfoMAsync(),
        watchSetSingleGroupListInfoAsync(),
        watchSetSingleGroupListInfoMAsync(),
    ]);
}
